import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_STATISTICS } from '@/api/endpoints';
import { useStudyYearPeriods } from '@/pages/Overview/hooks/useStudyYearPeriods';
import type {
  DisciplineType,
  NonAttendanceGroup,
  StudyYearPeriod,
} from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';
import { toApiDate } from '@/utils/date';

export interface DisciplineTypeStatistics {
  type: DisciplineType;
  attendableLessonsCount: number;
  total: number;
  justifiedCount: number;
  sicknessCount: number;
  otherCount: number;
  nonJustifiedCount: number;
}

export interface AttendanceStatistics {
  justified: NonAttendanceGroup[];
  nonJustified: NonAttendanceGroup[];
  disciplineTypes: DisciplineTypeStatistics[];
}

export const useAttendanceStatistics = (period: StudyYearPeriod) => {
  const { arePeriodsLoading } = useStudyYearPeriods();
  const from = toApiDate(period.from);
  const to = toApiDate(period.to);

  return useQuery<AttendanceStatistics>({
    queryKey: ['non-attendance-statistics', from, to],
    enabled: !arePeriodsLoading,
    queryFn: () =>
      apiClient
        .get<AttendanceStatistics>(API_NON_ATTENDANCE_STATISTICS, {
          params: {
            'datePeriodModel.from': from,
            'datePeriodModel.to': to,
          },
        })
        .then(unwrapAxiosResponse),
    placeholderData: keepPreviousData,
  });
};
